export default __webpack_public_path__ + "static/media/email_white.1136a977.svg";